import { inject, Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import {
  SnackbarComponent,
  SnackbarData,
  SnackbarState,
} from '../components/snackbar/snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {
  private _snackBar = inject(MatSnackBar);
  readonly SNACKBAR_DURATION = 3000;

  openSnackBar(
    message: string,
    state: SnackbarState = 'success',
  ): MatSnackBarRef<SnackbarComponent> {
    const data: SnackbarData = {
      message,
      state,
    };

    return this._snackBar.openFromComponent(SnackbarComponent, {
      data,
      duration: this.SNACKBAR_DURATION,
      direction: 'ltr',
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['transparent-snackbar-container'],
    });
  }

  dismiss(): void {
    this._snackBar.dismiss();
  }
}
